<template>
	<div>
    <v-btn color="green" dark fab small @click="dialogSubirVideo = true"><v-icon>mdi-video</v-icon></v-btn>

		<v-dialog
      v-model="dialogSubirVideo"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title>
          <span class="text-body-1 font-weight-black">Carga tu video aquí</span>
        </v-card-title>
        <v-card-text>
        	<div class="font-weight-black text-subtitle-1" align="justify">
	        	Esta sección es para evaluar tu habilidad de desenvolvimiento en el idioma inglés, debes de subir un video de una duración no mayor a 2 minutos y deberás presentarte (Nombre, edad, si estudias, trabajas o ambos y en qué nivel iniciaste) además de comentarnos cuál es tu hobby preferido y por qué. Recuerda hablar de la forma más natural posible.
	        	<br/>
	        	<br/>
	        </div>
        	<v-file-input
				    label="Cargar video"
				    filled
				    prepend-icon="mdi-camera"
				    accept="video/mp4,video/x-m4v,video/*"
				    v-model="videoCargado"
				  ></v-file-input>

			    <video id="video" 
			    	v-if="videoAmostrar"
      			:src="`${videoAmostrar}`" 
	    			frameborder="0" 
	    			allowfullscreen
	    			controls
	    			allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
	         	style="width: 100%; height: 100%; background: #FFFFFF;" allowtransparency="true">
	        </video>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            class="text-capitalize"
            dark
            rounded
            @click="videoAmostrar = null, videoCargado = null, dialogSubirVideo = false"
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            rounded
            @click="enviarDatos()"
            v-if="videoCargado"
            :disabled="cargar"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>


      <!-- Alertas -->
	    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
      <Loader    v-if="cargar"          :loader="loader"/>

    </v-dialog>
	</div>
</template>
<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

	export default {

		components:{
      Alerta,
      Loader
    },

		props:[
			'subirVideo'
	  ],

	  data: () => ({
	  	dialogSubirVideo: false,
	  	persona_beca:null,
	  	nombre: null,
	  	dialogCopiarEnlace: false,
	  	show: false,
	  	mensajeTooltip: '',
	  	videoCargado: null,
	  	fotoCargada: null,
	  	videoAmostrar:null,

      respuestaAlerta: false,

      loader: true,
      cargar: false,
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      alertaAcceso:{
        estatus: false,
      },
	  }),

	  watch: {
	  	videoCargado( value ){
	  		if( value ){ this.cargarVideo( value )}
	  	}
	  },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    methods:{
      async enviarDatos( ){
      	this.cargar = true
      	const id_usuario = base64.encode( this.getUsuarioLMS.id )
      	const id_grupo = base64.encode( this.subirVideo.id_grupo )

      	// Construimos el video para enviar
      	let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo
        formData.append("file", this.videoCargado);

      	this.$http.post(`subir.video/${id_usuario}/${id_grupo}`, formData ).then( response => {
      		this.cargar = false
      		this.dialogSubirVideo   = false
      		this.subirVideo.visible = false
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },


      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

      // Cargar tofo
      cargarVideo( video ){
        // creamos una variable tipo FormData
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file', video);
        //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
        this.getBase64(video, formData )
      },

      getBase64(archivo, formData) {
        var me = this
        // Creamos la variable de lectura
        var reader = new FileReader();
        // leemos el archivos
        reader.readAsDataURL(archivo);
        reader.onload =  function(){
          // Agregamos la foto cargada al arreglo que vamos a mostrar arriba en la pantalla
          me.videoAmostrar = reader.result
        }
      },
    }
  }
</script>



<style scoped>
  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }
  
  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }


  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button:increment,.v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button{
    display: none;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

</style>